<div style="display:flex; flex-direction:row; justify-content: space-between;">
    <menu-bar style="flex-grow:1" [menuTabs]="documentViews" (change)="selectDocumentView.emit($event)" [tabIdInit]="selectedDocumentId" data-ui-name="Menu bar" data-ui-component="documents-display" data-testid="documents-display-menu-bar"></menu-bar>
    <a *ngIf="showCloseButton" style="font-size:1.4em;" (click)="toggleDocuments.emit()" data-ui-name="Toggle Documents" data-ui-component="documents-display" data-testid="documents-display-toggle-documents">&times;</a>
</div>
<div *ngIf="activeDocument" [class.add-padding]="addPadding">
    <question-runner 
        [currentQuestion]="activeDocument" 
        [containingWidth]="containingWidth"
        [containingWidthSpill]="containingWidthSpill"
        [allowSubtitles]="allowSubtitles"
        [allowTranscripts]="allowTranscripts"
        [allowAudioPlaybackSpeed]="allowAudioPlaybackSpeed"
        [allowVideoPlaybackSpeed]="allowVideoPlaybackSpeed"
     data-ui-name="Question runner" data-ui-component="documents-display" data-testid="documents-display-question-runner"></question-runner>
</div>
